//calculation Helpers
export function isInLast12Months(date?: Date | string | null): boolean {
    if (!date) return false;

    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return false;

    const now = new Date();
    const cutoff = new Date();
    cutoff.setMonth(now.getMonth() - 12);

    return d >= cutoff && d <= now;
};

export function isInPrevious12Months(date?: Date | string | null): boolean {
    if (!date) return false;

    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return false;

    const now = new Date();
    const currentStart = new Date();
    currentStart.setMonth(now.getMonth() - 12);

    const previousStart = new Date();
    previousStart.setMonth(now.getMonth() - 24);

    return d >= previousStart && d < currentStart;
};


 //clear helper
   export function clearDropdown(selector: string): void {
    const $dd = $(selector);
    $dd.find('option').prop('selected', true);
    try { ($dd as any).selectpicker('refresh');
    } catch { }
        }


export function setSingleDropdownOptionByText(
    selector: string,
    label: string,
    options?: { allowToggleOff?: boolean; onToggleOff?: () => void }
): void {
    const $dd = $(selector);
    if (!$dd.length) return;

    const $options = $dd.find('option');
    const $match = $options.filter((_, opt) =>
        $(opt).text().trim().toLowerCase() === label.trim().toLowerCase()
    );

    if (!$match.length) return;

    const matchValue = String($match.first().val());
    const selected = ($dd.val() as string[] | null) ?? [];
    const isAlreadySingleSelected = selected.length === 1 && selected[0] === matchValue;

    if (options?.allowToggleOff && isAlreadySingleSelected) {
        options.onToggleOff?.();
        return;
    }

    $options.prop('selected', false);
    $match.prop('selected', true);

    try { ($dd as any).selectpicker('refresh'); } catch { }
}
export function isSingleDropdownOptionSelectedByText(
    selector: string,
    label: string
): boolean {
    const selected = ($(selector).val() as string[] | null) ?? [];
    if (selected.length !== 1) return false;

    const selectedText = $(`${selector} option[value="${selected[0]}"]`)
        .text()
        .trim()
        .toLowerCase();

    return selectedText === label.trim().toLowerCase();
}
export function getSelectionText(
    selected: string[] | null,
    label: string,
    options?: { requireSingle?: boolean; treatEmptyAsAll?: boolean }
): string | null {
    if (!selected) return null;
    if (options?.treatEmptyAsAll && selected.length === 0) return null;

    if (options?.requireSingle) {
        return selected.length === 1 ? `${label} selected` : null;
    }

    return selected.length > 0 ? `${label} selected` : null;
}

export type DataTableSearchBoxOptions = {
    sourceSelector: string; // DataTables generated search wrapper
    targetSelector: string; // your page-level search container
    placeholder?: string;
};

export function renderDataTableSearchBox(options: DataTableSearchBoxOptions): JQuery {
    const $source = $(options.sourceSelector);
    const $input = $source.find('input[type="search"]');

    if (!$source.length || !$input.length) return $();

    $input
        .addClass('form-control form-control-sm mb-0 custom-search-input')
        .attr('placeholder', options.placeholder ?? 'Search');

    const $target = $(options.targetSelector);

    $target.empty().html(`
        <div class="custom-search-box d-flex align-items-center">
            <button type="button"
                    class="custom-search-icon-btn"
                    tabindex="-1"
                    aria-label="Search">
                <i class="fas fa-search"></i>
            </button>

            <div class="custom-search-input-wrapper flex-grow-1"></div>
        </div>
    `);

    $target.find('.custom-search-input-wrapper').append($input);

    $source.remove();

    return $input;
}
export function readFilterValues(filterId: string): string[] | null {
    const $dd = $(`#${filterId}-dropdown`);
    if (!$dd.length) return null;

    const selected = ($dd.val() as string[] | null) ?? [];

    if (selected.length === 0) return null;

    return selected;
}